import { isEmpty } from "lodash/fp";

const BOT_PATH_REGEX = /^\/bot[?/]/g;

import { getLocalStorage } from "@readai/common/storage";

export const getLocalUser = () => {
  const jsonString = getLocalStorage().getItem("readUser");
  if (jsonString) {
    return { ...JSON.parse(jsonString), stale: true };
  }
  return null;
};

export const getUserId = () => {
  const user = getLocalUser();
  return user ? user.id : undefined;
};

export const getPageTitle = () => {
  const metaTitle = document.querySelector(
    "meta[name='mptitle']",
  ) as HTMLMetaElement | null;
  return metaTitle?.content || document.title;
};

/**
 * Returns a formatted event name for a page title.
 * Returns null if the title does not have a "-" separator
 * @example "Read - Dashboard" => Dashboard Page
 * @param title page title in the format "Read - Page Name"
 */
export const getEventFromPageTitle = (title: string) => {
  if (isEmpty(title) || title.trim() === "Read") {
    return null;
  }

  const parts = title.split("-");
  let spliceStart = 0;
  if (parts[0].trim() === "Read") {
    spliceStart = 1;
  }

  const pageName = parts
    .map((val) => val.trim())
    .splice(spliceStart)
    .join(" ")
    .trim();

  if (pageName.length === 0) {
    return null;
  }

  // eslint-disable-next-line lingui/no-unlocalized-strings
  return `${pageName} Page`;
};

export const isBotTraffic = (path: string): boolean => {
  return BOT_PATH_REGEX.test(path);
};
